<template>
  <div id="index">
    <el-container>
      <el-scrollbar :class="isCollapse ? 'menu_hide rightSide' : 'rightSide'">
        <el-main>
          <nav-bar></nav-bar>
          <el-form
            ref="formselect"
            :model="formselect"
            class="queryform_div"
            label-width="80px"
          >
            <el-row :gutter="24">
              <el-col :md="6" :xs="24" :sm="12">
                <el-form-item :label="$t('title.productLine')">
                  <el-select
                    @change="changeProductLine"
                    v-model="formselect.productLine"
                    style="width: 100%"
                    size="small"
                  >
                    <el-option :label="$t('desc.all')" value=""></el-option>
                    <el-option
                      v-for="item in productLineArr"
                      :key="item.bnDictCode"
                      :label="item.bnDictName"
                      :value="item.bnDictCode"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :md="6" :xs="24" :sm="12">
                <el-form-item :label="$t('acronym.airCompressorSN')" label-width="100px">
                  <el-input
                    type="text"
                    placeholder=" "
                    v-model="formselect.dsn"
                    size="small"
                  />
                </el-form-item>
              </el-col>
              <el-col :md="6" :xs="24" :sm="12">
                <el-form-item :label="$t('acronym.gatewaySN')">
                  <!-- <el-select
                      v-model="formselect.gsn"
                      :placeholder="$t('desc.select')"
                      style="width: 120px"
                    >
                      <el-option
                        v-for="item in gsnList"
                        :key="item.id"
                        :label="item.gsn"
                        :value="item.id"
                      >
                      </el-option>
                    </el-select> -->
                  <el-input
                    type="text"
                    placeholder=" "
                    v-model="formselect.gsn"
                    size="small"
                  />
                </el-form-item>
              </el-col>
              <el-col :md="6" :xs="24" :sm="12">
                <el-form-item :label="$t('acronym.gatewayBindingStatus')">
                  <el-select
                    size="small"
                    v-model="formselect.gatewayState"
                    :placeholder="$t('desc.select')"
                  >
                    <el-option value="全部" :label="$t('desc.all')"></el-option>
                    <el-option :label="$t('title.Bound')" value="1"></el-option>
                    <el-option
                      :label="$t('title.Unbound')"
                      value="0"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :md="6" :xs="24" :sm="12">
                <el-form-item :label="$t('acronym.ccn')" label-width="100px">
                  <el-input
                    type="text"
                    placeholder=" "
                    v-model="formselect.ccn"
                    size="small"
                  />
                </el-form-item>
              </el-col>
              <el-col :md="6" :xs="24" :sm="12">
                <el-form-item :label="$t('desc.customer')">
                  <el-input
                    type="text"
                    placeholder=" "
                    v-model="formselect.custName"
                    size="small"
                  />
                </el-form-item>
              </el-col>
              <el-col :md="6" :xs="24" :sm="12">
                <el-form-item :label="$t('acronym.installMethod')">
                  <el-select
                    size="small"
                    v-model="formselect.installMethod"
                    :placeholder="$t('desc.select')"
                  >
                    <el-option value="全部" :label="$t('desc.all')"></el-option>
                    <el-option
                      :label="$t('acronym.fieldInstallation')"
                      value="scene"
                    ></el-option>
                    <el-option
                      :label="$t('acronym.plantErection')"
                      value="factory"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              
              <el-col :md="6" :xs="24" :sm="12">
                <el-form-item :label="$t('acronym.gatewaystatus')">
                  <el-select
                    size="small"
                    v-model="formselect.gsnState"
                    :placeholder="$t('desc.select')"
                  >
                    <el-option value="99" :label="$t('desc.all')"></el-option>
                    <!-- <el-option
                      :label="$t('desc.DisconnectedNumber')"
                      value="0"
                    ></el-option> -->
                    <el-option :label="$t('desc.normal')" value="1"></el-option>
                    <el-option
                      :label="$t('tips.warning')"
                      value="2"
                    ></el-option>
                    <el-option
                      :label="$t('desc.offline')"
                      value="-1"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :md="12" :sm="12" :xs="24">
                <el-form-item
                  :label="$t('title.registerTime')"
                  style="min-height: 41px"
                >
                  <el-date-picker
                    v-model="formselect.times"
                    type="daterange"
                    value-format="yyyy-MM-dd HH:mm:ss"
                    align="right"
                    unlink-panels
                    :range-separator="$t('title.to')"
                    :start-placeholder="$t('title.beginDate')"
                    :end-placeholder="$t('title.endDate')"
                    style="width: 100%"
                    size="small"
                  >
                  </el-date-picker>
                </el-form-item>
              </el-col>
              <el-col :md="12" :xs="24" :sm="24">
                <el-form-item
                  :label="
                    $t('title.customerCenter') + '/' + $t('title.liaison')
                  "
                  label-width="120px"
                >
                  <template>
                    <el-cascader
                      collapse-tags
                      placeholder=""
                      size="small"
                      :props="{ multiple: true, checkStrictly: true }"
                      v-model="formselect.centerList"
                      :options="optionscenterShow"
                      style="width: 100%"
                    ></el-cascader>
                  </template>
                </el-form-item>
              </el-col>

              <!-- <el-col :md="8" :xs="24" :sm="12">
                <el-form-item :label="$t('desc.isContainWJ')">
                  <el-switch
                    v-model="formselect.isContainWJ"
                    active-color="#13ce66"
                    inactive-color="#ff4949"
                  >
                  </el-switch>
                </el-form-item>
              </el-col> -->
              <el-col :md="24" :xs="24" :sm="12">
                <el-form-item label=" ">
                  <el-button
                    type="primary"
                    @click="getDeviceList('search')"
                    size="small"
                    >{{ $t("button.query") }}</el-button
                  >
                  <el-button @click="resetKeyword" size="small">{{
                    $t("button.reset")
                  }}</el-button>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
          <template>
            <el-button
              type="primary"
              icon="el-icon-circle-plus-outline"
              @click="showDialog(true)"
              style="margin-bottom: 10px"
              v-if="hasCreateAuth"
              >{{ $t("title.airCompressorRegister") }}</el-button
            >
            <el-button
              type="default"
              icon="el-icon-upload2"
              @click="showImportDialog(true)"
              style="margin-bottom: 10px"
              v-show="hasImportAuth"
              >{{ $t("button.bulkImport") }}</el-button
            >
            <el-button
              type="default"
              icon="el-icon-upload2"
              @click="showImportServiceDialog(true)"
              style="margin-bottom: 10px"
              v-show="hasImportAuth"
              >{{ $t("button.bulkImportServiceType") }}</el-button
            >
            <el-button
              type="default"
              icon="el-icon-download"
              style="margin-bottom: 10px"
              @click="exportDeviceList()"
              :loading="loading"
              v-if="hasExportAuth"
              >{{ $t("button.exportAll") }}</el-button
            >
            <el-button
              type="default"
              icon="el-icon-download"
              style="margin-bottom: 10px"
              @click="downLoadMondayData()"
              :loading="ccn10ColockLoading"
              v-if="hasMondayIndexDownloadAuth"
              >{{ $t("button.exportEquipmentIndexData") }}</el-button
            >
            <a
              v-if="activeLang == 'en'"
              class="el-button el-button--default el-button--small"
              style="margin-bottom: 10px; text-decoration: none; float: right"
              href="/file/Excel Import Template - Air Compressor Service Type.xlsx"
              download="Excel Import Template - Air Compressor Service Type.xlsx"
              >{{ $t("desc.exportTemplateServiceType") }}</a
            >
            <a
              v-else
              class="el-button el-button--default el-button--small"
              style="margin-bottom: 10px; text-decoration: none; float: right"
              href="/file/EXCEL导入模板-空压机服务类型.xlsx"
              download="EXCEL导入模板-空压机服务类型.xlsx"
              >{{ $t("desc.exportTemplateServiceType") }}</a
            >
            <a
              v-if="activeLang == 'en'"
              class="el-button el-button--default el-button--small"
              style="margin-bottom: 10px; text-decoration: none; float: right"
              href="/file/Excel Import Template - Air Compressor.xlsx"
              download="Excel Import Template - Air Compressor.xlsx"
              >{{ $t("desc.exportTemplate") }}</a
            >
            <a
              v-else
              class="el-button el-button--default el-button--small"
              style="margin-bottom: 10px; text-decoration: none; float: right"
              href="/file/EXCEL导入模板-空压机.xlsx"
              download="EXCEL导入模板-空压机.xlsx"
              >{{ $t("desc.exportTemplate") }}</a
            >
            <!-- <el-button
              type="default"
              icon="el-icon-upload2"
              style="margin-bottom: 10px"
              v-show="hasCreateAuth"
              >批量导入</el-button
            > -->
            <div class="clear"></div>
            <div class="tableDiv">
              <el-table
                :data="tableData1"
                stripe
                style="width: 100%"
                :empty-text="$t('desc.noData')"
              >
                <el-table-column
                  type="index"
                  :label="$t('title.serialNumber')"
                  width="60"
                  fixed="left"
                >
                </el-table-column>
                <el-table-column
                  prop="dsn"
                  :label="$t('desc.airCompressorSN')"
                  width="140"
                  fixed="left"
                >
                </el-table-column>

                <el-table-column
                  prop="brandName"
                  :label="$t('title.brand')"
                  min-width="80"
                >
                </el-table-column>
                <el-table-column
                  prop="modelId"
                  :label="$t('title.airCompressorType')"
                  width="270"
                >
                </el-table-column>

                <el-table-column
                  prop="customerName"
                  :label="$t('desc.customer')"
                  width="310"
                >
                <template slot-scope="scope">
                    {{ containTranslate(scope.row.customerName) }}
                  </template>
                </el-table-column>
                <el-table-column
                  prop="compressorNumber"
                  :label="$t('desc.compressorNumber')"
                  width="100"
                >
                </el-table-column>
                <!-- <el-table-column
                  prop="customerCode"
                  label="客户代码"
                  width="100"
                >
                </el-table-column> -->

                <el-table-column
                  prop="serviceType"
                  :label="$t('title.airCompressorService')"
                  width="150"
                >
                </el-table-column>
                <el-table-column
                  prop="contractStatus"
                  :label="$t('desc.contractStatus')"
                  width="120"
                >
                  <template  slot-scope="scope">
                    {{ scope.row.contraStatus == 'Active'? $t('desc.withinTheContractWarrantyPeriod') :$t('desc.outsideTheContractWarrantyPeriod') }}
                  </template>
                </el-table-column>
                <el-table-column
                  prop="contractStartDate"
                  :label="$t('desc.contractStartDate')"
                  width="160"
                >
                </el-table-column>
                <el-table-column
                  prop="contractEndDate"
                  :label="$t('desc.contractEndDate')"
                  width="160"
                >
                </el-table-column>
                <el-table-column
                  prop="ccn"
                  :label="$t('title.controlsCCN')"
                  width="200"
                >
                </el-table-column>
                <el-table-column
                  prop="ccnVersion"
                  :label="$t('title.ccnVersion')"
                  width="120"
                >
                </el-table-column>
                <el-table-column
                  prop="gsn"
                  :label="$t('desc.gatewaySN')"
                  width="150"
                >
                </el-table-column>
                <el-table-column
                  v-if="hasDeviceLocation"
                  prop="locationAddress"
                  :label="$t('desc.locationAddress')"
                  width="150"
                >
                </el-table-column>
                <el-table-column
                  prop="lastUseRate"
                  :label="$t('desc.UtilizationRate')"
                  width="120"
                >
                </el-table-column>
                <el-table-column
                  prop="beatStatusName"
                  :label="$t('title.gatewaystatus')"
                  width="200"
                >
                  <template slot-scope="scope">
                    {{ $t("gatewayState." + scope.row.beatStatusName) }}
                  </template>
                </el-table-column>
                <el-table-column
                  prop="gatewayState"
                  :label="$t('title.isBinding')"
                  width="200"
                >
                </el-table-column>
                <el-table-column
                  prop="registerTime"
                  :label="$t('title.registerTime')"
                  width="200"
                >
                </el-table-column>
                <el-table-column
                  prop="lastBeatTime"
                  :label="$t('title.lastBeatTime')"
                  width="200"
                >
                </el-table-column>
                <el-table-column
                  prop="installMethod"
                  :label="$t('acronym.installMethod')"
                  width="150"
                >
                  <template slot-scope="scope">
                    <label>
                      {{ $t("acronym."+scope.row.installMethod) }}
                    </label>
                  </template>
                </el-table-column>
                
                <el-table-column
                  prop="responsibleServiceSalesName"
                  :label="$t('desc.responsibleServiceSalesName')"
                  width="120"
                >
                </el-table-column>
                <el-table-column
                  prop="responsibleServiceSalesMobile"
                  :label="$t('desc.responsibleServiceSalesMobile')"
                  width="140"
                >
                </el-table-column>
                <el-table-column
                  prop="responsibleEngineerName"
                  :label="$t('desc.responsibleEngineerName')"
                  width="120"
                >
                </el-table-column>
                <el-table-column
                  prop="responsibleEngineerMobile"
                  :label="$t('desc.responsibleEngineerMobile')"
                  width="140"
                >
                </el-table-column>
                <el-table-column
                  prop="installDate"
                  :label="$t('desc.installDate')"
                  width="140"
                >
                </el-table-column>
                <el-table-column
                  prop="lastOverhaulInstallDate"
                  :label="$t('desc.lastOverhaulInstallDate')"
                  width="140"
                >
                </el-table-column>
                <el-table-column
                  prop="uploadTime"
                  :label="$t('desc.lastOnlineTime')"
                  width="140"
                >
                </el-table-column>
                <el-table-column
                  prop="isConnectedAsset"
                  :label="$t('desc.isConnectedAsset')"
                  width="140"
                >
                  <template slot-scope="scope">
                    <label>
                      {{ scope.row.isConnectedAsset? $t("desc.是"):$t("desc.否") }}
                    </label>
                  </template>
                </el-table-column>
                <el-table-column
                  prop="digitalAssetStatus"
                  :label="$t('desc.isRegisteredAsset')"
                  width="140"
                >
                  <template slot-scope="scope">
                    <label>
                      {{ scope.row.digitalAssetStatus? $t("desc.是"):$t("desc.否") }}
                    </label>
                  </template>
                </el-table-column>

                <el-table-column
                  :label="$t('title.operate')"
                  width="250"
                  fixed="right"
                >
                  <template slot-scope="scope">
                    <el-button
                      icon=" fa fa-line-chart"
                      type="default"
                      circle
                      size="mini"
                      :title="$t('title.viewMonitor')"
                      v-if="hasMonitorAuth"
                      @click="openDevice(true, scope.row)"
                    ></el-button>
                    <el-popover placement="top" width="100" trigger="click">
                      <img
                        v-bind:src="
                          'data:image/jpeg;base64,' + scope.row.qrCodeImg
                        "
                        width="100"
                      />
                      <el-button
                        icon="fa fa-qrcode"
                        slot="reference"
                        type="info"
                        circle
                        size="mini"
                        v-if="hasQRCodeAuth"
                        :title="$t('button.QRcode')"
                      ></el-button>
                    </el-popover>
                    <el-button
                      icon=" fa fa-link"
                      type="success"
                      circle
                      size="mini"
                      v-if="
                        scope.row.gatewayState === $t('title.Unbound') &&
                        hasRegisterAuth
                      "
                      @click="showRegisterDialog(true, scope.row)"
                      :title="$t('button.gatewayBinding')"
                    ></el-button>
                    <template>
                      <el-popconfirm
                        placement="top"
                        :confirmButtonText="$t('button.relieveGateway')"
                        :cancelButtonText="$t('button.cancel')"
                        icon="el-icon-info"
                        iconColor="red"
                        :title="$t('tips.isRelieveGateway')"
                        @confirm="relieveGateway(scope.row.id)"
                      >
                        <el-button
                          icon=" fa fa-unlink"
                          type="danger"
                          circle
                          size="mini"
                          slot="reference"
                          v-show="
                            scope.row.gatewayState == $t('title.Bound') &&
                            hasUnBindAuth
                          "
                          :title="$t('button.relieveGateway')"
                        ></el-button>
                      </el-popconfirm>
                    </template>

                    <el-button
                      icon="fa fa-tasks"
                      type="warning"
                      circle
                      size="mini"
                      style="margin-top: 5px"
                      v-if="
                        scope.row.gatewayState === $t('title.Bound') &&
                        hasRePushGatherAuth
                      "
                      @click="pushGatherTable(scope.row.gsn)"
                      :title="$t('button.pushCcnTable')"
                    ></el-button>
                    <!-- 固件升级按钮 -->
                    <!-- <el-button
                      v-if="
                        scope.row.gatewayState == $t('title.Bound') &&
                        scope.row.beatStatus == '1' &&
                        hasDeviceUpgrade
                      "
                      type="primary"
                      icon="fa fa fa-arrow-up"
                      :title="$t('ota.firnwarUpgrade')"
                      circle
                      size="mini"
                      @click="showUpdateDialog(scope.row)"
                    ></el-button> -->

                    <el-button
                      type="primary"
                      icon="el-icon-edit"
                      :title="$t('button.update')"
                      circle
                      size="mini"
                      v-if="hasUpdateAuth"
                      @click="showEditDialog(true, scope.row)"
                    ></el-button>
                    <template>
                      <el-popconfirm
                        placement="top"
                        :confirmButtonText="$t('button.delete')"
                        :cancelButtonText="$t('button.cancel')"
                        icon="el-icon-info"
                        iconColor="red"
                        :title="$t('title.confirmDelete')"
                        @confirm="deleteDevice(scope.row.id)"
                      >
                        <el-button
                          type="danger"
                          icon="el-icon-delete"
                          :title="$t('button.delete')"
                          circle
                          size="mini"
                          slot="reference"
                          v-if="hasDeleteAuth"
                        ></el-button>
                      </el-popconfirm>
                    </template>

                    <template
                      v-if="false && hasDeviceLocation && scope.row.gatewayState === $t('title.Bound')"
                    >
                      <el-popconfirm
                        placement="top"
                        :confirmButtonText="$t('button.confirm')"
                        :cancelButtonText="$t('button.cancel')"
                        icon="el-icon-info"
                        iconColor="green"
                        :title="$t('desc.确定获取定位信息吗')"
                        @confirm="getLocationInfo(scope.row)"
                      >
                        <el-button
                          v-if="hasDeviceLocation"
                          type="primary"
                          icon="el-icon-location-information"
                          :title="$t('button.loaction')"
                          circle
                          size="mini"
                          slot="reference"
                        ></el-button>
                      </el-popconfirm>
                    </template>
                  </template>
                </el-table-column>
              </el-table>
              <el-pagination
                background
                :page-size="pagination.pageSize"
                :page-sizes="[10, 20, 50]"
                :current-page.sync="pagination.current"
                @current-change="handleCurrentChange"
                @size-change="handleSizeChange"
                layout="prev, pager, next,sizes"
                :total="pagination.totalPage"
                style="text-align: center; margin-top: 10px"
              >
              </el-pagination>
            </div>
          </template>
        </el-main>
      </el-scrollbar>
    </el-container>

    <gateway-dialog
      ref="registerRef"
      :refForm="'registerForm'"
      :title="(dialogTitle = $t('button.gatewayBinding'))"
      :gateway="gateway"
      :dialogAddAir="dialogAddAirRegist"
      :ccnList="ccnOptionsShowGate"
      :subButtonAuth="hasRegisterAuth"
      :ccnVersionOptions="ccnVersionOptions"
      :deviceModelType="deviceModelType"
      :loading="gatewayLoading"
      @onSubBtn="registeGateway"
      @dialogVisibleEvent="showRegisterDialog"
      @ccnChange="ccnChange"
      @changeCcnType="changeCcnType"
    >
    </gateway-dialog>



    <device-dialog
      ref="addRef"
      :refForm="'airFormAdd'"
      :title="(dialogTitle = $t('title.airCompressorRegister'))"
      :airform="airform"
      :dialogAddAir="dialogAddAir"
      :ccnList="ccnOptionsShow"
      :subButtonAuth="hasCreateAuth"
      :ccnVersionOptions="ccnVersionOptions"
      :activeLang="activeLang"
      :isEditChange="isEditChange"
      :loading="deviceLoading"
      @changeBrand="changeBrand"
      @changeModel="changeModel"
      @onSubBtn="addDevice"
      @dialogVisibleEvent="showDialog"
      @custChanged="custChanged"
      @ccnChange="ccnAddChange"
    >
    </device-dialog>

    <device-dialog
      ref="editRef"
      :refForm="'airFormEdit'"
      :title="(dialogTitle = $t('title.updateAirCompressor'))"
      :airform="airform"
      :dialogAddAir="dialogEditAir"
      :ccnList="ccnOptionsShow"
      :subButtonAuth="hasUpdateAuth"
      :ccnVersionOptions="ccnVersionOptions"
      :activeLang="activeLang"
      :isEditChange="isEditChange"
      :loading="deviceLoading"
      @changeBrand="changeBrand"
      @changeModel="changeModel"
      @onSubBtn="updateDevice"
      @dialogVisibleEvent="showEditDialog"
      @custChanged="custChanged"
      @ccnChange="ccnAddChange"
    >
    </device-dialog>
    <monitor-deviceInfo-Dialog
      ref="deviceInfoRef"
      :dialogClient="dialogDevice"
      :title="deviceTitle"
      :DeviceInfo="DeviceInfoShow"
      :CustomerInfo="CustomerInfo"
      :gatherOption="ccnGatherOption"
      :ccnCodeList222="ccnCodeList222"
      :activeLang="activeLang"
      :isDingOrBian="isDingOrBian"
      :echartID="echartID"
      :echartIDHistory="echartIDHistory"
      :maintainList="maintainList"
      :IsShowSensitive="IsShowSensitive"
      :UseRateData="UseRateData"
      :hasExportHistory="hasExportHistory"
      @getMonitorHistoryByGsn="getMonitorHistoryByGsn"
      @dialogVisibleEvent="openDevice"
      @openCcnTable="openCcnTable"
      @getRealData="getRealData"
      @changeCode="changeCode"
      @openMaintain="openMaintainDialog"
      @openTripWarning="openTripWarningDialog"
    >
    </monitor-deviceInfo-Dialog>
    <monitor-ccn-table
      :dialogClient="dialogDeviceCCN"
      :title="tableTitle"
      :tableCCN="tableCCN"
      :tableType="tableType"
      @dialogVisibleEvent="openCcnTable"
    >
    </monitor-ccn-table>
    <import-dialog
      ref="importRef"
      :refForm="'airFormImport'"
      :title="(dialogTitle = $t('button.bulkImportCustomer'))"
      :dialogImportClient="dialogImportClient"
      :form="form"
      :loading="importLoading"
      @onSubBtn="uploadFile"
      @dialogVisibleEvent="showImportDialog"
    ></import-dialog>

    <import-dialog
      ref="serviceimportRef"
      :refForm="'serviceFormImport'"
      :title="(dialogTitle = $t('button.bulkImportServiceType'))"
      :dialogImportClient="dialogImportService"
      :form="serivceform"
      :loading="importLoading"
      @onSubBtn="uploadServiceType"
      @dialogVisibleEvent="showImportServiceDialog"
    ></import-dialog>

    <monitor-maintain-dialog
      :dialogClient="dialogMaintain"
      :title="maintainTitle"
      :serviceform="serviceform"
      :tableService="tableService"
      @dialogVisibleEvent="openMaintainDialog"
    >
    </monitor-maintain-dialog>
    <!-- <monitor-TripWarning-Dialog
      :dialogClient="dialogTripWarning"
      title="告警监控"
      @dialogVisibleEvent="openTripWarningDialog"    
    >
    </monitor-TripWarning-Dialog> -->
    <!-- 固件版本升级 弹出框 -->
    <el-dialog
      :title="$t('ota.firnwarUpgrade')"
      :visible.sync="dialogUpdate"
      width="80%"
      top="5vh"
    >
      <el-form ref="formUpdate" :model="formUpdate" label-width="130px">
        <el-row :gutter="24">
          <el-col :span="12">
            <el-form-item :label="$t('desc.airCompressorSN')">
              <el-input v-model="formUpdate.dsn" :disabled="true"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$t('ota.geteWayName')">
              <el-input v-model="formUpdate.GSN" :disabled="true"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$t('ota.oldVersion')">
              <el-input
                v-model="formUpdate.OldVersion"
                :disabled="true"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-form-item :label="$t('ota.newVersion')">
          <div class="tableDiv">
            <el-table
              :data="VersionTable"
              ref="VersionTable"
              stripe
              class="formSTable NoRaidoLabel"
              :empty-text="$t('desc.noData')"
              :height="VersionTHeight"
            >
              <el-table-column label=" " width="55px" align="center">
                <template slot-scope="scope">
                  <el-radio
                    v-model="currentRowId"
                    :label="scope.row.id"
                    @change="changeRedio($event, scope.row)"
                    >&nbsp;</el-radio
                  >
                </template>
              </el-table-column>
              <el-table-column
                :label="$t('ota.FirmwareName')"
                prop="versionName"
                min-width="30%"
              >
              </el-table-column>
              <!-- <el-table-column :label="$t('ota.DeviceModel')" prop="deviceType" min-width="15%">
            </el-table-column> -->
              <el-table-column
                :label="$t('ota.VersionNumber')"
                prop="versionNo"
                min-width="30%"
              >
              </el-table-column>
              <el-table-column
                :label="$t('ota.deviceType')"
                prop="deviceType"
                min-width="30%"
              >
                <template slot-scope="scope">
                  {{ $t("ota." + scope.row.deviceType) }}
                </template>
              </el-table-column>
              <el-table-column :label="$t('title.creatTime')" min-width="30%">
                <template slot-scope="scope">
                  {{ scope.row.creationTime | dateFormat }}
                </template>
              </el-table-column>
            </el-table>
          </div>
        </el-form-item>
        <el-form-item>
          <el-button @click="createJob" type="success">{{
            $t("button.confirm")
          }}</el-button>
          <el-button @click="dialogUpdate = false">{{
            $t("button.cancel")
          }}</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>



  </div>
</template>
<script>
import {
  getDeviceList,
  addDevice,
  deleteDevice,
  updateDevice,
  getDeviceById,
  deviceBindGateway,
  relieveBindGateway,
  getGateways,
  getCcnInfos,
  getCcnInfosWithType,
  GetDeviceStations,
  pushGatherTable,
  authOperationCheck,
  getCustomerRegionTree,
  importDevice,
  exportExcelNew,
  getExportDeviceList,
  getAllOTAInfo,
  getByGsn,
  creatOTAJob,
  importServiceType,
  getProductLines,
  getMonday10Data,
  getDeviceLocation,
  getDeviceModelById, GetDeviceBasicInfo, GetDeviceRateList, GetCycleCoreData, GetLifecycleCoreData
} from "../../api/api";
import deviceDialogComponent from "../../components/content/maintabber/CompressorDialog";
import gatewayRegisterComponent from "../../components/content/maintabber/GatewayRegisterDialog";
import monitorDeviceInfoDialog from "../../components/content/monitor/MonitorDeviceInfoDialog";
import monitorCcnTable from "../../components/content/monitor/MonitorCcnTable";
import monitorMaintainDialog from "../../components/content/monitor/MonitorMaintainDialog";
import monitorTripWarningDialog from "../../components/content/monitor/MonitorTripWarning";
import agencyImportComponent from "../../components/content/maintabber/ExportExcelFile";
import healthReport from "../../views/report/healthReport";
import { monitorMixin } from "../../mixins/monitorMixin";
import { mapState, mapGetters, mapActions, mapMutations } from "vuex";

export default {
  name: "index",
  components: {
    "device-dialog": deviceDialogComponent,
    "gateway-dialog": gatewayRegisterComponent,
    "monitor-deviceInfo-Dialog": monitorDeviceInfoDialog,
    "monitor-ccn-table": monitorCcnTable,
    "import-dialog": agencyImportComponent,
    "monitor-maintain-dialog": monitorMaintainDialog,
    "monitor-TripWarning-Dialog": monitorTripWarningDialog,
    "health-report": healthReport
  },
  mixins: [monitorMixin],
  computed: {
    ...mapGetters({
      activeLang: "language",
    }),
    ...mapState({
      isCollapse: (state) => state.isCollapse,
      navselected: (state) => state.adminleftnavnum,
    }),
  },
  data() {
    return {
      gatewayLoading:false,
      deviceLoading:false,
      pacCcnFilterArr:
      ["System Pressure",
      "Stage 1 Temperature",
      "Stage 1 Vibration",
      "Stage 1 Pressure",
      "Stage 2 Temperature",
      "Stage 2 Vibration",
      "Stage 2 Pressure",
      "Stage 3 Temperature",
      "Stage 3 Vibration",
      "Stage 3 Pressure"],
      loading: false,
      importLoading: false,
      dialogImportClient: false,
      dialogImportService: false,
      deviceModelType: "",
      form: {
        datalist: [],
      },
      serivceform: {
        datalist: [],
      },
      gsnStateList: {
        0: "未连接",
        1: "正常",
        2: "警告",
        "-1": "脱机",
      },
      refForm: "",
      dialogTitle: "",
      gsnList: [],
      gsnListWithoutUse: [],
      ccnList: [],
      ActiveTab: "first",
      dialogAddAirRegist: false,
      dialogAddAir: false,
      dialogEditAir: false,
      hasUpdateAuth: false,
      hasDeleteAuth: false,
      hasCreateAuth: false,
      hasRegisterAuth: false,
      hasUnBindAuth: false,
      hasQRCodeAuth: false,
      hasRePushGatherAuth: false,
      hasMonitorAuth: false,
      hasImportAuth: false,
      hasExportAuth: false,
      hasDeviceUpgrade: false,
      hasExportHistory: false,
      hasDeviceLocation: false,
      hasMondayIndexDownloadAuth: false,
      formselect: {
        isContainWJ: true,
        gatewayState: "",
        gsnState: "",
      },
      tableData1: [],
      gateway: {
        dsn: "",
        modelName: "",
        customerName: "",
        serviceType: "",
        gsn: "",
        gatewayId: "",
        signal: "",
        dbm: "",
        ccn: "",
        ccnType: "",
        ccnIp: "",
        ccnPort: "",
        ccnVersion: "",
        ccnBaudrate: "9600",
        ccnDatabits: "8",
        ccnStopbit: "1",
        ccnCheckbit: "n",
        ccnCom: "COM1",
        ccnGatherList: [],
        ccnModel: "",
      },
      custOption: [],
      brandCustOption: [],
      airform: {
        Dsn: "",
        ModelId: "",
        CustomerId: "",
        ModelList: [],
        ServiceType: "",
        Ccn: "",
        ccnVersion: "",
        CustomerName: "",
        CustomerCode: "",
        StationId: "",
        StationName: "",
        HardwareSn: "",
      },
      airoptions: [],
      airModelOptions: [],
      stationList: [],
      ccnVersionOptions: [],
      ccnOptions: [],
      ccnOptionsShow: [],
      ccnOptionsShowGate: [],
      pagination: {
        current: 1,
        pageSize: 10,
        totalPage: 0,
      },

      //空压机详细
      dialogMonitor: false,
      ccnNameList: [],
      translateList: {
        定期保养: "desc.pmPureLabor",
        一次性保养: "desc.oneTimePM",
        延长保修: "desc.extendWarranty",
        工厂保内: "desc.factoryWarranty",
        其他: "desc.other",
      },
      bondStatusTraslate: {
        已绑定: "title.Bound",
        未绑定: "title.Unbound",
      },
      //告警
      alarmList: [],
      dialogUpdate: false,
      currentRowId: "",

      // formUpdate: {
      //   GSN: "GL5012047000256",
      //   OldVersion: "2.0.0r13575",
      // },
      formUpdate: {
        dsn: "",
        GSN: "",
        OldVersion: "",
        getWayName: "",
        versionName: "",
        deviceType: "",
        versionNo: "",
        describeContent: "",
      },
      VersionTable: [],
      otaformselect: {
        name: "",
        type: "",
      },
      VersionTHeight: "",
      dialogTripWarning: false,
      failTime: 0,
      optionscenter: [],
      optionscenterShow:[],
      isEditChange: false,
      productLineArr:[],
      ccn10ColockLoading:false,
      healthReportProp: {
        dsn: "",
        gsn: "",
        deviceBasicInfo:{},
        deviceUseRateList:[],
        cycleCoreData:{},
        deviceLoadedRateList:[],
        lifecycleCoreData:{}
      },
      healthReportDialog: false
    };
  },
  created: function () {
    this.authOperation("Device");
    
    var _self = this;
    window.onresize = () => {
      if (_self.$refs.registerRef) {
        _self.$refs.registerRef.resize();
      }
    };
  },
  async mounted() {
    if (this.$route.params.gatewayState) {
      // this.formselect.gatewayState = this.$route.params.gatewayState;
      this.$set(
        this.formselect,
        "gatewayState",
        this.$route.params.gatewayState
      );
    }
    if (this.$route.params.isContainWJ) {
      if (this.$route.params.isContainWJ == "true") {
        this.$set(this.formselect, "isContainWJ", true);
      } else {
        this.$set(this.formselect, "isContainWJ", false);
      }
    }
    if (this.$route.params.custName) {
      this.$set(this.formselect, "custName", this.$route.params.custName);
    }
    if (this.$route.params.gsnState) {
      this.$set(this.formselect, "gsnState", this.$route.params.gsnState);
      // this.formselect.gsnState = this.$route.params.gsnState;
    }
    if (this.$route.params.times) {
      let date = new Date();
      let year = date.getFullYear();
      let curMonth = date.getMonth() + 1;
      // 如果传过来的月份大于当前月份，那就是上一年
      let [month, day] = this.$route.params.times.split("-");
      if (Number(month) > curMonth) {
        year = year - 1;
      }
      let time = `${year}-${month}-${day} 00:00:00`;
      this.$set(this.formselect, "times", [time, time]);
    }
    if (this.$route.params.installMethod) {
      this.$set(
        this.formselect,
        "installMethod",
        this.$route.params.installMethod
      );
    }
    this.getProductLines();
    this.getCustomerRegionTree();

    this.getDeviceList();
    this.getCcnInfos();
    this.getCcnInfosDistinct();
    this.getOtaData();
  },
  methods: {
    authOperation(curPage) {
      var that = this;
      var res = authOperationCheck(curPage);
      that.hasCreateAuth = res.hasCreateAuth;
      that.hasUpdateAuth = res.hasUpdateAuth;
      that.hasDeleteAuth = res.hasDeleteAuth;
      that.hasRegisterAuth = res.hasRegisterAuth;
      that.hasUnBindAuth = res.hasUnBindAuth;
      that.hasQRCodeAuth = res.hasQRCodeAuth;
      that.hasRePushGatherAuth = res.hasRePushGatherAuth;
      that.hasMonitorAuth = res.hasMonitorAuth;
      that.hasImportAuth = res.hasImportAuth;
      that.hasExportAuth = res.hasExportAuth;
      that.hasDeviceUpgrade = res.hasDeviceUpgrade;
      that.hasExportHistory = res.hasExportHistory;
      that.hasDeviceLocation = res.hasDeviceLocation;
      that.hasMondayIndexDownloadAuth = res.hasMondayIndexDownloadAuth;
    },
    async getProductLines(){
      let that=this;
      let res = await getProductLines();
      that.productLineArr = res.result;
    },
    getCustomerRegionTree() {
      let that = this;
      getCustomerRegionTree().then((res) => {
        let data = res.result;
        that.optionscenter = data;
      });
    },
    changeProductLine(){
      let that = this;
      let brand = localStorage.getItem("user_brand") ? localStorage.getItem("user_brand") : "IR"
      that.optionscenterShow=that.optionscenter.filter(a=>a.brand==brand && a.centerType == this.formselect.productLine);
    },
    changeBrand() {
      // this.brandCustOption = JSON.parse(JSON.stringify(this.custOption));
      // this.airModelOptions = this.airoptions.filter(
      //   (x) => x.brand == this.airform.brandCode
      // );
    },

    getGateways() {
      let that = this;
      let data = { gsn: "1" };
      getGateways(data).then((res) => {
        let data = res.result;
        that.gsnList = data;
      });
    },

    getCcnInfosDistinct() {
      getCcnInfosWithType().then((res) => {
        let data = res.result;
        this.ccnOptions = data;
        // for (let index = 0; index < data.length; index++) {
        //   if (!this.ccnOptions.some(item=>item.ccn===data[index].ccn)) {
        //     this.ccnOptions.push(data[index]);
        //   }
        // }
        // this.$set(this.gateway, "ccn", this.gateway.ccn);
      });
    },
    changeModel(type){
      let that = this;
      if (type == "离心机") {
        that.ccnOptionsShow = that.ccnOptions.filter(a=> a.ccnType == 'PAC').map(a=>a.ccn)
      }else{
        that.ccnOptionsShow = that.ccnOptions.filter(a=> a.ccnType !== 'PAC').map(a=>a.ccn)
      }
      
    },
    getCcnInfos() {
      getCcnInfos("", "", "", "").then((res) => {
        let data = res.result;
        this.ccnList = data;
      });
    },
    async getDeviceList(type = "normal") {
      let that = this;
      if (type == "search") {
        this.pagination.current = 1;
      }
      let skipcount = (this.pagination.current - 1) * this.pagination.pageSize;
      let postData = {
        Dsn: this.formselect.dsn,
        Gsn: this.formselect.gsn,
        GatewayState: this.formselect.gatewayState,
        Ccn: this.formselect.ccn,
        CustName: this.formselect.custName,
        GsnState: this.formselect.gsnState,
        Language: this.activeLang,
        SkipCount: skipcount,
        MaxResultCount: this.pagination.pageSize,
        Time: this.formselect.times,
        InstallMethod: this.formselect.installMethod,
        isContainWJ: this.formselect.isContainWJ,
        CenterList: this.formselect.centerList,
        ProdunctLine: this.formselect.productLine,
      };
      getDeviceList(postData)
        .then((res) => {
          let data = res.result.items;
          this.pagination.totalPage = res.result.totalCount;
          that.tableData1 = data;
          for (let index = 0; index < data.length; index++) {
            that.tableData1[index].beatStatusName =
              that.gsnStateList[that.tableData1[index].beatStatus];
            that.tableData1[index].lastUseRate =
              that.tableData1[index].lastUseRate + "%";
            if (that.translateList[that.tableData1[index].serviceType]) {
              that.tableData1[index].serviceType = that.$t(
                that.translateList[that.tableData1[index].serviceType]
              );
            }
            that.tableData1[index].gatewayState = that.$t(
              that.bondStatusTraslate[that.tableData1[index].gatewayState]
            );
          }
        })
        .catch((err) => {});
    },
    exportDeviceList() {
      let that = this;
      that.loading = true;

      var fileName = that.$t("desc.equipmentRegistrationList")+".csv";
      let postData = {
        Dsn: this.formselect.dsn,
        Gsn: this.formselect.gsn,
        GatewayState: this.formselect.gatewayState,
        Ccn: this.formselect.ccn,
        CustName: this.formselect.custName,
        GsnState: this.formselect.gsnState,
        Language: this.activeLang,
        SkipCount: 0,
        MaxResultCount: 100000,
        Time: this.formselect.times,
        InstallMethod: this.formselect.installMethod,
        isContainWJ: this.formselect.isContainWJ,
        CenterList: this.formselect.centerList,
        ProdunctLine: this.formselect.productLine,
      };
      getExportDeviceList(postData).then((res) => {
        if (res.result) {
          let data = res.result.items;
          for (let index = 0; index < data.length; index++) {
            data[index].beatStatusName =
              that.gsnStateList[data[index].beatStatus];
            data[index].lastUseRate = data[index].lastUseRate + "%";
            if (that.translateList[data[index].serviceType]) {
              data[index].serviceType = that.$t(
                that.translateList[data[index].serviceType]
              );
            }
            data[index].gatewayState = that.$t(
              that.bondStatusTraslate[data[index].gatewayState]
            );
          }
          //导入数据里有null会导致文件损坏
          const dataSource = data.map((item) => {
            Object.keys(item).forEach((key) => {
              // 后端传null node写入会有问题
              if (item[key] === null) {
                item[key] = "";
              }

              if (Array.isArray(item[key])) {
                item[key] = item[key].join(",");
              }
            });
            return item;
          });
          let header = [
            that.$t('desc.airCompressorSN'),
            that.$t('title.brand'),
            that.$t('title.productLine'),
            that.$t('title.productCategories'),
            that.$t('title.smallClassProduct'),
            that.$t('title.machineType'),
            that.$t('title.customerCode'),
            that.$t('desc.customerName'),
            that.$t('title.customerType'),
            that.$t('title.customerCenter'),
            that.$t('desc.compressorNumber'),
            that.$t('title.airCompressorService'),
            that.$t('desc.contractStatus'),
            that.$t('desc.contractStartDate'),
            that.$t('desc.contractEndDate'),
            that.$t('title.controlsCCN'),
            that.$t('title.ccnVersion'),
            that.$t('desc.gatewaySN'),
            that.$t('desc.UtilizationRate'),
            that.$t('title.gatewaystatus'),
            that.$t('title.isBinding'),
            that.$t('title.registerTime'),
            that.$t('title.lastBeatTime'),
            that.$t('acronym.installMethod'),
            that.$t('desc.responsibleServiceSalesName'),
            that.$t('desc.responsibleEngineerName'),
            that.$t('desc.installDate'),
            that.$t('desc.lastOverhaulInstallDate'),
            that.$t('desc.lastOnlineTime'),
            that.$t('desc.isConnectedAsset'),
            that.$t('desc.isRegisteredAsset'),
          ];
          let exportContent = new Array();
          dataSource.forEach((item) => {
            let rowData = new Object();
            rowData = {
              dsn: item.dsn,
              brandName: item.brandName,
              kType: item.kType,
              kProduct: item.kProduct,
              kSmall: item.kSmall,
              kPower: item.kPower,
              customerCode: item.customerName.split("_")[0]?item.customerName.split("_")[0]:"",
              customerName: item.customerName.split("_")[1]?item.customerName.split("_")[1]:"",
              customerType: that.containTranslate(item.customerName.split("_")[2]?item.customerName.split("_")[2]:""),
              customerCenter: item.customerName.split("_")[3]?item.customerName.split("_")[3]:"",
              compressorNumber: item.compressorNumber,
              serviceType: item.serviceType,
              contractStatus: item.contractStatus,
              contractStartDate: item.contractStartDate,
              contractEndDate: item.contractEndDate,
              ccn: item.ccn,
              ccnVersion: item.ccnVersion,
              gsn: item.gsn,
              lastUseRate: item.lastUseRate,
              beatStatusName: that.$t("gatewayState." +item.beatStatusName),
              gatewayState: item.gatewayState,
              registerTime: item.registerTime,
              lastBeatTime: item.lastBeatTime,
              installMethod: item.installMethod?that.$t("acronym."+item.installMethod):"",
              responsibleServiceSalesName: item.responsibleServiceSalesName,
              responsibleEngineerName: item.responsibleEngineerName,
              installDate: item.installDate,
              lastOverhaulInstallDate: item.lastOverhaulInstallDate,
              uploadTime: item.uploadTime,
              isConnectedAsset: item.isConnectedAsset? that.$t("desc.是"):that.$t("desc.否"),
              digitalAssetStatus: item.digitalAssetStatus? that.$t("desc.是"):that.$t("desc.否")
            };
            exportContent.push(rowData);
          });
          // CsvExportor.downloadCsv(exportContent,{header},fileName);
          exportExcelNew({ header }, fileName, exportContent);
          that.loading = false;
        }
      });
    },
    async getDeviceById(e, type) {
      let that = this;
      let data = { id: e, Language: this.activeLang };
      let res = await getDeviceById(data);
      if (type == "register") {
        that.gateway = res.result;
        this.ccnChange(that.gateway.ccn);
      } else {
        that.airform = res.result;
        this.isEditChange = true;
        this.changeBrand();
        this.ccnAddChange(that.airform.ccn, that.airform.ccnVersion);
      }
    },
    addDevice() {
      let that = this;
      that.deviceLoading = true;
      addDevice(that.airform)
        .then((res) => {
          that.deviceLoading = false;
          that.dialogAddAir = false;
          that.$message({
            showClose: true,
            message: that.$t("tips.saveSuccess"),
            type: "success",
          });
          that.getDeviceList();
          that.airform = {
            Dsn: "",
            ModelId: "",
            ModelList: [],
            CustomerId: "",
            ServiceType: "",
            Ccn: "",
            CustomerName: "",
            CustomerCode: "",
          };
        })
        .catch((err) => {
          that.deviceLoading = false;
          that.$message({
            showClose: true,
            message: err.error.message,
            type: "error",
          });
        });
    },
    deleteDevice(e) {
      let that = this;
      let data = { id: e };
      deleteDevice(data)
        .then((res) => {
          that.$message({
            showClose: true,
            message: this.$t("tips.deleteSuccess"),
            type: "success",
          });
          that.getDeviceList();
        })
        .catch((err) => {
          that.$message({
            showClose: true,
            message: err.error.message,
            type: "error",
          });
        });
    },
    updateDevice() {
      let that = this;
      that.deviceLoading = true;
      updateDevice(that.airform)
        .then((res) => {
          that.deviceLoading = false;
          that.dialogEditAir = false;
          that.$message({
            showClose: true,
            message: that.$t("tips.updateSuccess"),
            type: "success",
          });
          that.getDeviceList();
        })
        .catch((err) => {
          that.deviceLoading = false;
          that.$message({
            showClose: true,
            message: err.error.message,
            type: "error",
          });
        });
    },
    async registeGateway() {
      let that = this;
      that.gatewayLoading = true;
      try {
        // var res = await deviceBindGateway(that.gateway);
        // console.log(JSON.stringify(res));
        // that.dialogAddAirRegist = false;
        // that.$message({
        //   showClose: true,
        //   message: that.$t("tips.bindSuccess"),
        //   type: "success",
        // });
        // that.getDeviceList();

        await deviceBindGateway(that.gateway).then((res) => {
          that.gatewayLoading = false;
          that.dialogAddAirRegist = false;
          that.$message({
            showClose: true,
            message: that.$t("tips.bindSuccess"),
            type: "success",
          });
          that.getDeviceList();
        });
      } catch (error) {
        that.gatewayLoading = false;
        this.$message.error(error.error.message);
      }
    },
    relieveGateway(e) {
      let that = this;
      let data = { id: e };
      relieveBindGateway(data).then((res) => {
        that.$message({
          showClose: true,
          message: that.$t("tips.relieveSuccess"),
          type: "success",
        });
        that.getDeviceList();
      });
    },
    pushGatherTable(gsn) {
      let that = this;
      var para = {
        Ccn: "",
        Gsn: gsn,
      };
      pushGatherTable(para)
        .then((res) => {
          let ret = res.result;
          that.$message({
            message: that.$t("tips.oprationSuccess"),
            type: "success",
          });
        })
        .catch((err) => {
          that.$message({
            showClose: true,
            message: err.error.message,
            type: "error",
          });
        });
    },

    getStationOption() {
      let that = this;
      GetDeviceStations().then((res) => {
        let data = res.result;
        that.stationList = data;
      });
    },
    custChanged(value) {
      // let that = this;
      // that.stationOptions = that.stationList.filter(
      //   (item) => item.customerId === value
      // );
      // this.$set(this.airform, "stationId", "");
    },
    showDialog(visible) {
      this.dialogAddAir = visible;
      if (visible) {
        // this.getStationOption();
        // this.airModelOptions = [];
        // this.brandCustOption = [];
        this.airform = {
          Dsn: "",
          ModelId: "",
          CustomerId: "",
          ModelList: [],
          ServiceType: "",
          Ccn: "",
          CustomerName: "",
          CustomerCode: "",
          compressorNumber: "",
        };
        //打开窗口前重置验证
        if (this.$refs.addRef.$refs.airFormAdd != undefined) {
          this.$refs.addRef.$refs.airFormAdd.resetFields();
        }
        let brand = localStorage.getItem("user_brand")
          ? localStorage.getItem("user_brand")
          : "IR";
        this.$set(this.airform, "brandCode", brand);
      } else {
        this.isEditChange = false;
      }
    },
    async showEditDialog(visible, row) {
      this.dialogEditAir = visible;
      if (visible) {
        // this.airModelOptions = [];
        // this.brandCustOption = [];
        //打开窗口前重置验证
        if (this.$refs.editRef.$refs.airFormEdit != undefined) {
          this.$refs.editRef.$refs.airFormEdit.resetFields();
        }

        this.custChanged(row.customerId);
        await this.getDeviceById(row.id, "edit");
      } else {
        this.airform.customerCode = "";
        this.airform.ccn = "";
        this.airform.serviceType = "";
        this.airform.modelList = [];
        this.airform.compressorNumber = "";
        this.isEditChange = false;
        // this.airform = {
        //   Dsn: "",
        //   CustomerId: "",
        //   ServiceType: "",
        //   Ccn: "",
        //   CustomerName: "",
        //   CustomerCode: "",
        // };
      }
    },
    async showRegisterDialog(visible, row) {
      this.dialogAddAirRegist = visible;
      if (visible) {
        // console.log(row.productLineType)
        if (row.productLineType >= "PAC") {
          this.deviceModelType = "PAC";
        } else {
          this.deviceModelType = "Other";
        }
        // console.log(this.deviceModelType)
        this.ccnOptionsShowGate = this.ccnOptions.filter(a=> a.ccnType.toLowerCase() == row.productLineType.toLowerCase())
        await this.getDeviceById(row.id, "register");

        this.$nextTick(() => {
          if (this.$refs.registerRef.$refs.registerForm != undefined) {
            this.$refs.registerRef.$refs.registerForm.resetFields();
          }
        });
        // if (this.$refs.registerRef.$refs.registerForm != undefined) {
        //   this.$refs.registerRef.$refs.registerForm.resetFields();
        // }
      } else {
        this.gateway = {};
      }
    },
    closeHealthReport() {
      this.healthReportProp = {
        dsn: "",
        gsn: "",
        deviceBasicInfo:{},
        deviceUseRateList:[],
        cycleCoreData:{},
        deviceLoadedRateList:[],
        lifecycleCoreData:{}
      };
    },
    async showHealthReportDialog(row) {
      this.healthReportProp.dsn = row.dsn;
      this.healthReportProp.gsn = row.gsn;
      this.healthReportProp.deviceUseRateList = await this.deviceUseRateList();
      this.healthReportProp.deviceBasicInfo = await this.deviceBasicInfo();
      this.healthReportProp.deviceLoadedRateList = await this.deviceLoadedRateList();
      this.healthReportProp.cycleCoreData = await this.cycleCoreData();
      this.healthReportProp.lifecycleCoreData = await this.lifecycleCoreData();

      this.$refs.healthReportDialog.showDialog(true);
    },
   async deviceBasicInfo() {
      if (this.healthReportProp.dsn && this.healthReportProp.gsn) {
        let res = await GetDeviceBasicInfo(this.healthReportProp.dsn, this.healthReportProp.gsn);
        if (!res || !res.result) {
          return {};
        }
        return res.result;
      }
      return {};
    },
    async deviceUseRateList() {
      if (this.healthReportProp.dsn && this.healthReportProp.gsn) {
        let res2 = await GetDeviceRateList(this.healthReportProp.dsn, this.healthReportProp.gsn, 'use');
        if (!res2 || !res2.result) {
          return [];
        }
        return res2.result;
      }
      return [];
    },
    async cycleCoreData() {
      if (this.healthReportProp.dsn && this.healthReportProp.gsn) {
        let res2 = await GetCycleCoreData(this.healthReportProp.dsn, this.healthReportProp.gsn);
        if (!res2|| !res2.result) {
          return {};
        }
        res2.result.WarningInfo = JSON.parse(res2.result.WarningInfo || "[]");
        res2.result.TripInfo = JSON.parse(res2.result.TripInfo || "[]");
        return res2.result;
      }
      return {};
    },
    async deviceLoadedRateList() {
      if (this.healthReportProp.dsn && this.healthReportProp.gsn) {
        let res2 = await GetDeviceRateList(this.healthReportProp.dsn, this.healthReportProp.gsn, 'loaded');
        if (!res2 || !res2.result) {
          return [];
        }
        return res2.result;
      }
      return [];
    },
    async lifecycleCoreData() {
      if (this.healthReportProp.dsn && this.healthReportProp.gsn) {
        let res = await GetLifecycleCoreData(this.healthReportProp.dsn, this.healthReportProp.gsn);
        if (!res || !res.result) {
          return {};
        }
        return res.result;
      }
      return {};
    },
    openNotice() {
      this.$notify({
        title: "警告",
        message: "这是一条警告的提示消息",
        type: "warning",
      });
    },
    togleCollapse() {
      this.isCollapse = !this.isCollapse;
    },

    handleAccredit(index, row) {
      console.log(index, row);
    },
    handleDelete(index, row) {
      console.log(index, row);
    },
    onSubmit() {},
    resetKeyword() {
      this.formselect = {};
    },
    ccnChange(value) {
      this.ccnVersionOptions = this.ccnList
        .filter((item) => item.ccn == value)
        .sort((a, b) => {
          return a.version - b.version;
        });
      if (!this.gateway.ccn) {
        this.$set(this.gateway, "ccnVersion", "");
      } else {
        this.$set(
          this.gateway,
          "ccnVersion",
          this.ccnVersionOptions[0].version
        );
      }
    },
    ccnAddChange(value, version) {
      this.ccnVersionOptions = this.ccnList
        .filter((item) => item.ccn == value)
        .sort((a, b) => {
          return a.version - b.version;
        });
      if (!this.airform.ccn) {
        this.$set(this.airform, "ccnVersion", "");
      } else {
        if (version) {
          this.$set(this.airform, "ccnVersion", version);
        } else {
          this.$set(
            this.airform,
            "ccnVersion",
            this.ccnVersionOptions[0].version
          );
        }
      }
    },
    handleCurrentChange(val) {
      this.pagination.current = val;
      this.getDeviceList();
    },
    handleSizeChange(val) {
      this.pagination.pageSize = val;
      this.getDeviceList();
    },

    //监控

    showImportDialog(visible) {
      this.dialogImportClient = visible;
      this.form.datalist = [];
      if (this.$refs.importRef.$refs.airFormImport != undefined) {
        this.$refs.importRef.$refs.airFormImport.resetFields();
      }
    },
    showImportServiceDialog(visible) {
      this.dialogImportService = visible;
      this.serivceform.datalist = [];
      if (this.$refs.serviceimportRef.$refs.serviceFormImport != undefined) {
        this.$refs.serviceimportRef.$refs.serviceFormImport.resetFields();
      }
    },
    uploadFile() {
      let that = this;
      this.importLoading = true;
      var datalist = that.form.datalist;
      // var propertys = Object.keys(datalist[0]);
      // if (propertys.length != 30) {
      //   that.form.datalist = [];
      //   that.$message({
      //     showClose: true,
      //     message: "导入格式不正确",
      //     type: "error",
      //   });
      //   return false;
      // }
      var msgArr = [];
      var index = 2;
      var postData = [];
      let customerCharater = {
        "Directly Managed":"直管",
        "Distributor Managed":"经销商",
        "Service Distributor":"服务经销商",
        "Middleman":"中间商",
        "Others":"其他",
      }
      datalist.map((v) => {
        let obj = {};
        if (that.activeLang == 'en'){
          obj.Type = v["类型"];
          obj.Dsn = v["Dsn"];
          obj.CustomerName = v["Customer Name"];
          obj.CustomerCode = v["Customer Code"];
          obj.CompanyType = customerCharater[v["Customer Charater"]];
          obj.ManageCpName = v["Management Owner"];
          obj.KType = v["Product Line"];
          obj.kProduct = v["Product Category"];
          obj.KSmall = v["Power Range"];
          obj.KPower = v["Model"];
          obj.BrandCode = v["Brand"];
          obj.ProductFamily = v["Product Family"];
          obj.Power = v["Power"];
          obj.DischargePressure = v["Discharge Pressure"];
          obj.CoolingMode = v["Cooling Mode"];
          obj.CompressorNumber = v["Compressor Number"];
        }else {
          obj.Type = v["类型"];
          obj.Dsn = v["序列号"];
          obj.CustomerName = v["最终客户"];
          obj.CustomerCode = v["客户代码"];
          obj.CompanyType = v["单位性质"];
          obj.ManageCpName = v["管理单位"];
          obj.KType = v["服务产品线"];
          obj.kProduct = v["产品分类"];
          obj.KSmall = v["服务产品小类"];
          obj.KPower = v["机型"];
          obj.BrandCode = v["品牌"];
          obj.ProductFamily = v["产品族"];
          obj.Power = v["功率"];
          obj.DischargePressure = v["排气压力"];
          obj.CoolingMode = v["冷却方式"];
          obj.CompressorNumber = v["空压机编号"];
        }
        
        var msg = "";
        if (obj.Dsn == undefined || obj.Dsn == "") {
          msg = that.$t("importError.dsnIsEmpty");;
        }
        if (msg != "") {
          msgArr.push(that.$t("importError.exceptionLine") + index + that.$t("importError.行异常:") + msg);
        } else {
          if (that.find(postData, obj) > -1) {
            msgArr.push(
              that.$t("importError.exceptionLine") +
                index +
                that.$t("importError.行异常:")+
                that.$t("importError.theSameDsnAlreadyExists") +
                obj.Dsn
            );
          } else {
            // if (obj.Type=="新增") {

            // }
            postData.push(obj);
          }
        }
        index++;
      });
      if (msgArr.length > 0) {
        that.$message({
          showClose: true,
          dangerouslyUseHTMLString: true,
          message: msgArr.join("<br/>"),
          type: "error",
        });
        this.importLoading = false;
        return false;
      }
      importDevice(postData, 2 * 60 * 1000)
        .then((res) => {
          that.dialogImportClient = false;
          this.importLoading = false;
          that.$message({
            showClose: true,
            message: that.$t("tips.importSuccess"),
            type: "success",
          });
          that.getDeviceList();
        })
        .catch((err) => {
          this.importLoading = false;
          
          if (err.error.message.indexOf("系统中不存在客户：") > -1 && that.activeLang == 'en') {
            err.error.message = err.error.message.replace("系统中不存在客户：","These customers do not exist in the system: ")
          }
          that.$message({
            showClose: true,
            message: err.error.message,
            type: "error",
          });
        });
    },

    uploadServiceType() {
      let that = this;
      this.importLoading = true;
      var datalist = that.serivceform.datalist;
      // var propertys = Object.keys(datalist[0]);
      // if (propertys.length != 30) {
      //   that.form.datalist = [];
      //   that.$message({
      //     showClose: true,
      //     message: "导入格式不正确",
      //     type: "error",
      //   });
      //   return false;
      // }
      var msgArr = [];
      var index = 2;
      var postData = [];
      datalist.map((v) => {
        let obj = {};
        if (that.activeLang == 'en') {
          obj.Dsn = v["Dsn"];
          obj.ServiceType = v["Service Type"];
        }else {
          obj.Dsn = v["设备SN号"];
          obj.ServiceType = v["服务类型"];
        }
        
        obj.BrandCode = localStorage.getItem("user_brand")
          ? localStorage.getItem("user_brand")
          : "IR";
        var msg = "";
        if (obj.Dsn == undefined || obj.Dsn == "") {
          msg = that.$t("importError.dsnIsEmpty");
        }
        if (msg != "") {
          msgArr.push(that.$t("importError.exceptionLine") + index + that.$t("importError.行异常:") + msg);
        } else {
          if (that.find(postData, obj) > -1) {
            msgArr.push(
              that.$t("importError.exceptionLine") +
                index +
                that.$t("importError.行异常:")+
                that.$t("importError.theSameDsnAlreadyExists") +
                obj.Dsn
            );
          } else {
            // if (obj.Type=="新增") {

            // }
            postData.push(obj);
          }
        }
        index++;
      });
      if (msgArr.length > 0) {
        that.$message({
          showClose: true,
          dangerouslyUseHTMLString: true,
          message: msgArr.join("<br/>"),
          type: "error",
        });
        this.importLoading = false;
        return false;
      }
      importServiceType(postData, 2 * 60 * 1000)
        .then((res) => {
          that.dialogImportService = false;
          this.importLoading = false;
          that.$message({
            showClose: true,
            message: that.$t("tips.importSuccess"),
            type: "success",
          });
          that.getDeviceList();
        })
        .catch((err) => {
          that.$message({
            showClose: true,
            message: err.error.message,
            type: "error",
          });
        });
    },
    find(array, model) {
      var index = array.findIndex((item) => item.Dsn === model.Dsn);
      return index; // -1 说明array中不存在id为str的对象
    },

    getOtaData() {
      var data = this.otaformselect;
      data.SkipCount = 0; //(this.pagination.current - 1) * this.pagination.pageSize
      data.MaxResultCount = 10; //this.pagination.pageSize;
      getAllOTAInfo(data).then((res) => {
        if (res.success) {
          //this.pagination.totalPage = res.result.totalCount
          //this.loading = false
          this.VersionTable = res.result.items;
        }
      });
    },

    getDetailByGsn(row) {
      var data = { gsn: row.gsn };
      data.SkipCount = 0; //(this.pagination.current - 1) * this.pagination.pageSize
      data.MaxResultCount = 10; //this.pagination.pageSize;
      getByGsn(data).then((res) => {
        if (res.success) {
          //this.pagination.totalPage = res.result.totalCount
          //this.loading = false
          this.formUpdate.dsn = row.dsn;
          this.formUpdate.GSN = res.result.gsn;
          this.formUpdate.getWayName = res.result.gatewayName;
          this.formUpdate.OldVersion = res.result.firmwareVersion;
        }
      });
    },

    createJob(row) {
      let data = {
        id: this.currentRowId,
        gsn: this.formUpdate.GSN,
      };
      if (this.currentRowId) {
        creatOTAJob(data).then((res) => {
          if (res.success) {
            if (res.result.jobId) {
              this.$message.success(this.$t("ota.upgradeSuccess"));
              this.getDeviceList();
              this.dialogUpdate = false;
            } else {
              this.$message.warning(res.result.description);
            }
          } else {
            this.$message.error(res.error.message);
          }
        });
      } else {
        this.$message.warning(this.$t("ota.selectVersion"));
      }
    },

    showUpdateDialog(row) {
      this.dialogUpdate = true;
      this.getDetailByGsn(row);
      this.VersionTHeight = window.innerHeight * 0.9 - 330 + "px";
    },
    // changeRedio($event, row){
    //   alert(this.currentRowId)
    // },
    changeCcnType(val) {
      if (val === "RTU") {
        if (this.gateway.gsn.includes('NIRHC')) {
          this.$set(this.gateway, "ccnBaudrate", "115200");
        } else {
          this.$set(this.gateway, "ccnBaudrate", "9600");
        }
        this.$set(this.gateway, "ccnDatabits", "8");
        this.$set(this.gateway, "ccnStopbit", "1");
        this.$set(this.gateway, "ccnCheckbit", "n");
        this.$set(this.gateway, "ccnCom", "COM1");
      }
      if(val=="TCP"){        
        this.$set(this.gateway, "ccnIp", "192.168.2.100");
        this.$set(this.gateway, "ccnPort", "502");
      }
    },
    openTripWarningDialog(visible) {
      this.dialogTripWarning = visible;
    },
    SetMapHeight() {
      this.TableH = window.innerHeight * 0.8 - 190 + "px";
    },
    containTranslate(str) {
      let containArr = ['直管', '经销商', '服务经销商', '中间商', '其他'];
      let result="";
      containArr.forEach(element=>{
        if (str.indexOf(element) > -1) {
          let displayStr = this.$t('desc.'+element);
          result = str.replace(element,displayStr);
        }
      });
      return result;
    },
    async downLoadMondayData() {
      const that = this;
      that.ccn10ColockLoading = true;
      let skipcount = (this.pagination.current - 1) * this.pagination.pageSize
      let postData = {
        Dsn: this.formselect.dsn,
        Gsn: this.formselect.gsn,
        GatewayState: this.formselect.gatewayState,
        Ccn: this.formselect.ccn,
        CustName: this.formselect.custName,
        GsnState: this.formselect.gsnState,
        Language: this.activeLang,
        // SkipCount: 0,
        // MaxResultCount: 100000,
        Time: this.formselect.times,
        InstallMethod: this.formselect.installMethod,
        isContainWJ: this.formselect.isContainWJ,
        CenterList: this.formselect.centerList,
        ProdunctLine: this.formselect.productLine,
        SkipCount: skipcount,
        MaxResultCount: this.pagination.pageSize,
      };
      try {
        let res = await getMonday10Data(postData);
        let data = res.result;
        debugger
        
        let exportData = new Array();
        let titleList = [
          that.$t('desc.gatewaySN'),
          that.$t('desc.airCompressorSN'),
          that.$t('title.machineType'),
          that.$t('title.controlsCCN'),
          that.$t('title.brand'),
          that.$t('desc.customerName'),
          that.$t('title.customerCenter'),
          that.$t('desc.responsibleEngineerName'),
          that.$t('title.AirCompressorStatus'),
          that.$t('title.RunningTime'),
          that.$t('title.LoadedTime'),
          that.$t('title.RatedPressure'),
        ];
        let ccnIndexList =new Array();
        for (let index = 0; index < data.length; index++) {
          const element = data[index];
          ccnIndexList.push(...element.ccnIndexList);
        }
        const indexList = that.unique(ccnIndexList.map(a=>a.nameEn))
        titleList.push(...indexList);
        titleList.push(that.$t('desc.timestamp'));
        exportData.push(titleList);
        let fileName = this.$t("button.exportEquipmentIndexData") + ".xlsx";

        for (let index = 0; index < data.length; index++) {
          const element = data[index];
          let rowData = [
            element.gsn,
            element.dsn,
            element.wholeModelName,
            element.ccn,
            element.brandName,
            element.customerName,
            element.customerCenter,
            element.responsibleEngineerName,
            element.compressorStatus,
            element.runningTime,
            element.loadingTime,
            element.ratedPressure,
          ];
          for (let j = 0; j < indexList.length; j++) {
            const indexElement = indexList[j];
            const curIndexValue = element.ccnIndexList.find(a=>a.nameEn == indexElement);
            rowData.push(curIndexValue?.value??"");
          }
          rowData.push(element.timeStamp)
          exportData.push(rowData);
        }
        //导入数据里有null会导致文件损坏
        const dataSource = exportData.map((item) => {
            Object.keys(item).forEach((key) => {
              // 后端传null node写入会有问题
              if (item[key] === null) {
                item[key] = "";
              }

              if (Array.isArray(item[key])) {
                item[key] = item[key].join(",");
              }
            });
            return item;
          });
        exportExcelNew(exportData, fileName);
        this.ccn10ColockLoading = false;
      } catch (error) {
        this.ccn10ColockLoading = false;
        this.$message({
          showClose: true,
          message: this.$t("desc.exportFailed"),
          type: "success",
        });
      }
    },
    unique(arr) {//去重
      const res = new Map();
      return arr.filter((a) => !res.has(a) && res.set(a, 1));
    },
    async getLocationInfo(row) {
      try {
        let res = await getDeviceLocation(row.dsn);
        if (res.result == true) {
          this.$message.success(this.$t("sim.locationsuccess"));
          await this.getDeviceList('search');
        } else {
          this.$message.warning(this.$t("sim.locationFail"));
        }
      } catch (error) {
        this.$message.warning(this.$t("sim.locationFail"));
      }
    },
    hasHealthReportAuth(type) {
      let type1 = type || "";
      type1 = type1.toLowerCase();
      if (type1 === "packagecare" || type1 === "partscare" || type1 === "plannedcare") {
        return true;
      }
      return false;
    }
  },
};
</script>
<style scoped>
.infodiv {
  margin-top: 5px;
  border: 1px solid #d2d2d2;
  padding: 10px;
  border-radius: 5px;
  background-color: #f3f3f3;
}
#formPer .el-form-item__content {
  line-height: 35px;
  border-left: 1px solid #ebeef5;
  padding-left: 10px;
}

#formPer > .el-form-item {
  margin-bottom: 0px;
  border-bottom: 1px solid #ebeef5;
}

#formPer .noborder .el-form-item__content {
  border: 0;
}

#formPer .noborder {
  border: 0;
  margin-top: 20px;
}
</style>
<style scope>
.el-table__fixed-right {
  right: 0px !important;
}
</style>
<style  scope>
.NoRaidoLabel .el-table__row .el-radio__label {
  display: none;
}
.el-checkbox__input.is-disabled.is-checked .el-checkbox__inner::after {
  border-color: #000000;
}
</style>
 